"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapAttributions_vue_1 = __importDefault(require("@becrop/components/Rate/vue/components/MapAttributions.vue"));
let MapOlControls = class MapOlControls extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isSamplesView = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'top-end' })
], MapOlControls.prototype, "controlsPosition", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapOlControls.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: null,
    })
], MapOlControls.prototype, "controlsConfig", void 0);
MapOlControls = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Focus: lucide_vue_next_1.Focus,
            Plus: lucide_vue_next_1.Plus,
            Minus: lucide_vue_next_1.Minus,
            Maximize2: lucide_vue_next_1.Maximize2,
            Download: lucide_vue_next_1.Download,
            Pencil: lucide_vue_next_1.Pencil,
            Info: lucide_vue_next_1.Info,
            EyeOff: lucide_vue_next_1.EyeOff,
            Eye: lucide_vue_next_1.Eye,
            Button: bmk_ui_framework_1.Button,
            MapAttributions: MapAttributions_vue_1.default,
        },
    })
], MapOlControls);
exports.default = MapOlControls;
